import { RuleLock } from 'Slices/Omnichannel/LockSlice'

//equality function to prevent locks unnecessary rerender that force tables rerender and tabulation reset
//IMPORTANT: this function has the purpose to prevent above issue. Anyway it still require us remember to set
//this function on every app selector.
//Note for a future code improvement in order to prevent this behavior
const customEqual = (oldValue: RuleLock[], newValue: RuleLock[]) => {
  if (oldValue.length !== newValue.length) return false
  for (let i = 0; i < oldValue.length; i++) {
    if (oldValue[i].ruleId !== newValue[i].ruleId || oldValue[i].userId !== newValue[i].userId) return false
  }
  return true
}

export { customEqual }
